// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"0fa50890","354":"586f8c82","371":"cb9e00e3","688":"29abf016","905":"f8899921","959":"3affd3e6"}[chunkId] + ".chunk.js";
};